import moment from 'moment-timezone';

const DEFAULT_TIMEZONE = 'UTC';

type DriveToStoreLineItem = {
  beginDate?: Date | string | null;
  endDate?: Date | string | null;
  timezone?: string;
};

// Available from the day after the begin date until the last day of the month after the end date's month.
export function isDriveToStoreReportAvailable(lineItem: DriveToStoreLineItem, now: Date = new Date()): boolean {
  if (!lineItem.beginDate || !lineItem.endDate) {
    return false;
  }

  const zone = lineItem.timezone && moment.tz.zone(lineItem.timezone) ? lineItem.timezone : DEFAULT_TIMEZONE;
  const today = moment.tz(now, zone).startOf('day');
  const availableFrom = moment.tz(lineItem.beginDate, zone).startOf('day').add(1, 'day');
  const availableUntil = moment.tz(lineItem.endDate, zone).add(1, 'month').endOf('month');

  return today.isSameOrAfter(availableFrom, 'day') && today.isSameOrBefore(availableUntil, 'day');
}
